'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndAppAlternateId } from '../../Entities/Ind/IndAppAlternateId';

export class IndAppAlternateIdRepository extends CoreRepository {
  public addIndAppAlternateIds(userId: number, payload: any[]) {
    return this.webAPI.addIndAppAlternateIds(userId, payload).then((response) => {
      return response;
    });
  }

  public getIndAppAlternateIds(userId: number, individualId: number, options: object = null) {
    return this.webAPI.getIndAppAlternateIds(userId, individualId, options).then((response) => {
      return response;
    });
  }

  public removeIndAppAlternateId(userId: number, individualId: number, alternateId: number) {
    return this.webAPI
      .removeIndAppAlternateId(userId, individualId, alternateId)
      .then((response) => {
        return response;
      });
  }
}
